var _TooltipView_isTooltipOpen;
import { __classPrivateFieldGet, __classPrivateFieldSet, __rest } from "tslib";
import React from 'react';
import { Popup } from '@gravity-ui/uikit';
import { isFunction } from '../../../lodash';
import { logger } from '../../../logger';
import { ErrorLoggerBoundary } from '../../../react-utils/ErrorBoundary';
import { Toolbar } from '../../../toolbar';
import { getReactRendererFromState } from '../ReactRenderer';
const SelectionTooltip = (_a) => {
    var { show, poppupProps } = _a, toolbarProps = __rest(_a, ["show", "poppupProps"]);
    if (!show)
        return null;
    return (React.createElement(Popup, Object.assign({ open: true }, poppupProps, { style: { padding: '4px 8px' } }),
        React.createElement(Toolbar, Object.assign({}, toolbarProps))));
};
export class TooltipView {
    constructor(actions, menuConfig) {
        _TooltipView_isTooltipOpen.set(this, false);
        this.baseProps = { show: false, poppupProps: {} };
        this._tooltipRenderItem = null;
        this.actions = actions;
        this.menuConfig = menuConfig;
    }
    get isTooltipOpen() {
        return __classPrivateFieldGet(this, _TooltipView_isTooltipOpen, "f");
    }
    show(view, popupProps) {
        this.view = view;
        __classPrivateFieldSet(this, _TooltipView_isTooltipOpen, true, "f");
        this.baseProps = {
            show: true,
            poppupProps: Object.assign(Object.assign({}, popupProps), this.calcPosition(view)),
        };
        this.renderPopup();
    }
    hide(view) {
        this.view = view;
        __classPrivateFieldSet(this, _TooltipView_isTooltipOpen, false, "f");
        this.baseProps = { show: false, poppupProps: {} };
        this.renderPopup();
    }
    destroy() {
        var _a;
        (_a = this._tooltipRenderItem) === null || _a === void 0 ? void 0 : _a.remove();
        this._tooltipRenderItem = null;
    }
    getSelectionTooltipProps() {
        return Object.assign(Object.assign({}, this.baseProps), { focus: () => this.view.focus(), data: this.getFilteredConfig(), editor: this.actions, onClick: (id) => logger.action({ mode: 'wysiwyg', source: 'context-menu', action: id }) });
    }
    getFilteredConfig() {
        return this.baseProps.show
            ? this.menuConfig
                .map((groupData) => groupData.filter(({ condition }) => isFunction(condition) ? condition(this.view.state) : true))
                .filter((groupData) => Boolean(groupData.length))
            : [];
    }
    renderPopup() {
        this.tooltipRenderItem.rerender();
    }
    get tooltipRenderItem() {
        if (!this._tooltipRenderItem) {
            const reactRenderer = getReactRendererFromState(this.view.state);
            this._tooltipRenderItem = reactRenderer.createItem('selection_context', () => (React.createElement(ErrorLoggerBoundary, null,
                React.createElement(SelectionTooltip, Object.assign({}, this.getSelectionTooltipProps())))));
        }
        return this._tooltipRenderItem;
    }
    calcPosition(view) {
        const viewDom = view.dom;
        // The box in which the tooltip is positioned, to use as base
        const viewBox = viewDom.getBoundingClientRect();
        const viewWidth = viewBox.right - viewBox.left;
        const viewHalfWidth = viewWidth / 2;
        // These are in screen coordinates
        const start = view.coordsAtPos(view.state.selection.from);
        const end = view.coordsAtPos(view.state.selection.to);
        // Find a center-ish x position from the selection endpoints (when
        // crossing lines, end may be more to the left)
        const left = Math.max((start.left + end.left) / 2, start.left + 3);
        const leftOffset = left - (viewBox.left + viewHalfWidth);
        const bottomOffset = -(viewBox.bottom - end.bottom) + this.popupTextOffset;
        return {
            placement: 'bottom',
            anchorRef: { current: viewDom },
            offset: [leftOffset, bottomOffset],
        };
    }
    get popupTextOffset() {
        return 4; // 4px offset from text selection
    }
}
_TooltipView_isTooltipOpen = new WeakMap();
